<template>
  <div>
    <div class="mian_box">
      <el-dialog
        title="添加试题"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        @close="resetForm('ruleForm')"
      >
        <div class="Popup_view">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="选择题型：">
              <el-select
                v-model="form.topic"
                value-key="id"
                placeholder="请选择"
                @change="choose"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.label"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="题型名称：">
              <el-input v-model.trim="form.topicName"></el-input>
            </el-form-item>
          </el-form>
          <!-- 内容 -->
          <div v-if="state == 1" class="rule_mian">
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="题干：" prop="Title" class="text_one">
                <el-input
                  type="textarea"
                  v-model.trim="ruleForm.Title"
                  placeholder="请输入题干"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="答案："
                prop="Answer"
                class="text_one"
                v-for="(item, index) in ruleForm.Answer"
                :key="index"
              >
                <div class="answer_oper">
                  <el-input
                    type="textarea"
                    v-model.trim="item.value"
                    placeholder="请输入答案"
                  ></el-input>
                  <i
                    class="iconfont icon-zu11540"
                    @click="deletes"
                    v-if="
                      index == ruleForm.Answer.length - 1 &&
                      ruleForm.Answer.length > 1
                    "
                  ></i>
                </div>
              </el-form-item>
              <el-button class="oper_box" @click="addAnswer">
                <i class="iconfont icon-action-add-hover"></i>添加答案
              </el-button>
              <el-form-item label="解析：" prop="Explain">
                <div class="parsing">
                  <el-input
                    type="textarea"
                    v-model.trim="ruleForm.Explain"
                    placeholder="请输入解析"
                    maxlength="250"
                    show-word-limit
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div v-else-if="state == 2" class="rule_mian">
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="题干：" prop="Title" class="text_one">
                <el-input
                  type="textarea"
                  v-model.trim="ruleForm.Title"
                  placeholder="请输入题干"
                ></el-input>
              </el-form-item>
              <el-form-item label="答案：" prop="isAnswer" class="text_one">
                <div class="answer">
                  <el-input
                    type="textarea"
                    v-model.trim="ruleForm.isAnswer"
                    placeholder="请输入答案"
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item label="解析：" prop="Explain">
                <div class="parsing">
                  <el-input
                    type="textarea"
                    v-model.trim="ruleForm.Explain"
                    placeholder="请输入解析"
                    maxlength="250"
                    show-word-limit
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div v-else-if="state == 3" class="choice_mian">
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="题干：" prop="Title" class="text_one">
                <el-input
                  type="textarea"
                  v-model.trim="ruleForm.Title"
                  placeholder="请输入题干"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项：" prop="radioArr" class="text_one">
                <div v-for="(item, index) in ruleForm.radioArr" :key="index">
                  <div class="options_view">
                    <div class="options_text">{{ add(index) }}</div>
                    <div class="options_box">
                      <el-input v-model="item.value"></el-input>
                      <i
                        class="iconfont icon-zu11540"
                        @click="deletes(index)"
                        v-if="index > 1 && ruleForm.radioArr.length > 2"
                      ></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <!-- 单选题的单选框 -->
              <el-form-item
                label="答案："
                prop="options"
                class="check_box text_one"
              >
                <el-radio-group v-model="ruleForm.isslectradio">
                  <div v-for="(item, index) in ruleForm.radioArr" :key="index">
                    <div class="radio">
                      <el-radio :label="add(index)">{{ add(index) }}</el-radio>
                    </div>
                  </div>
                </el-radio-group>
              </el-form-item>
              <el-button class="oper_box" @click="addAnswer">
                <i class="iconfont icon-action-add-hover"></i>添加选项
              </el-button>
              <el-form-item label="解析：" prop="Explain">
                <div class="parsing">
                  <el-input
                    type="textarea"
                    v-model.trim="ruleForm.Explain"
                    placeholder="请输入解析"
                    maxlength="250"
                    show-word-limit
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div v-else-if="state == 4" class="choice_mian">
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="题干：" prop="Title" class="text_one">
                <el-input
                  type="textarea"
                  v-model.trim="ruleForm.Title"
                  placeholder="请输入题干"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项：" prop="options" class="text_one">
                <div v-for="(item, index) in ruleForm.options" :key="index">
                  <div class="options_view">
                    <div class="options_text">{{ add(index) }}</div>
                    <div class="options_box">
                      <el-input v-model.trim="item.value"></el-input>
                      <i
                        class="iconfont icon-zu11540"
                        @click="deletes(index)"
                        v-if="index > 1 && ruleForm.options.length > 2"
                      ></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <!-- 多选题的多选框 -->
              <el-form-item
                label="答案："
                prop="options"
                class="check_box text_one"
              >
                <el-checkbox-group v-model="ruleForm.checkList">
                  <div v-for="(item, index) in ruleForm.options" :key="index">
                    <el-checkbox :label="add(index)">{{
                      add(index)
                    }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </el-form-item>
              <el-button class="oper_box" @click="addAnswer">
                <i class="iconfont icon-action-add-hover"></i>添加选项
              </el-button>
              <el-form-item label="解析：" prop="Explain">
                <div class="parsing">
                  <el-input
                    type="textarea"
                    v-model.trim="ruleForm.Explain"
                    placeholder="请输入解析"
                    maxlength="250"
                    show-word-limit
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div v-else-if="state == 5" class="small_choice">
            <el-form
              :model="smallForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="题干：" prop="MainTitle" class="text_one">
                <el-input
                  type="textarea"
                  v-model.trim="smallForm.MainTitle"
                  placeholder="请输入题干"
                ></el-input>
              </el-form-item>
              <!-- 小题盒子部分 -->
              <el-form-item>
                <div class="samll_topic">
                  <div class="samll_left">
                    <div
                      @click="switchtable(index)"
                      v-for="(item, index) in A3TestItem"
                      :key="index"
                      :class="istrueindex == index ? 'active' : ''"
                    >
                      <div>小题{{ index + 1 }}</div>
                    </div>
                  </div>
                  <div class="samll_right">
                    <el-button @click="gitSmall">
                      <i class="iconfont icon-action-add-hover"></i>添加小题
                    </el-button>
                    <el-button @click="deleteSmall('共享题')">
                      <i class="iconfont icon-zu11540"></i>删除小题
                    </el-button>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="小题干：" prop="Title" class="text_one">
                <el-input
                  type="textarea"
                  v-model.trim="A3TestItem[istrueindex].Title"
                  placeholder="请输入小题干"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项：" prop="SelectedItem" class="text_one">
                <div
                  v-for="(item, index) in A3TestItem[istrueindex].SelectedItem"
                  :key="index"
                >
                  <div class="options_view">
                    <div class="options_text">{{ add(index) }}</div>
                    <div class="options_box">
                      <el-input v-model.trim="item.value"></el-input>
                      <i
                        class="iconfont icon-zu11540"
                        @click="smallRadioDele(index, '共享题')"
                        v-if="index > 1 && ruleForm.radioArr.length > 2"
                      ></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <!-- 共用题干单选题的单选框 -->
              <el-form-item
                label="答案："
                prop="options"
                class="check_box text_one"
              >
                <el-radio-group v-model="A3TestItem[istrueindex].Answer">
                  <div
                    v-for="(item, index) in A3TestItem[istrueindex]
                      .SelectedItem"
                    :key="index"
                  >
                    <div class="radio">
                      <el-radio :label="add(index)">{{ add(index) }}</el-radio>
                    </div>
                  </div>
                </el-radio-group>
              </el-form-item>
              <el-button class="oper_box" @click="addSmallRadio('共用题干')">
                <i class="iconfont icon-action-add-hover"></i>添加选项
              </el-button>
              <el-form-item label="解析：" prop="parsing">
                <div class="parsing">
                  <el-input
                    type="textarea"
                    v-model.trim="A3TestItem[istrueindex].parsing"
                    placeholder="请输入解析"
                    maxlength="250"
                    show-word-limit
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div v-else-if="state == 6" class="small_choice">
            <el-form
              :model="smallForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="题干：" prop="MainTitle2" class="text_one">
                <el-input
                  type="textarea"
                  v-model.trim="smallForm.MainTitle2"
                  placeholder="请输入题干"
                ></el-input>
              </el-form-item>
              <!-- 小题盒子部分 -->
              <el-form-item>
                <div class="samll_topic">
                  <div class="samll_left">
                    <div
                      @click="switchtable(index)"
                      v-for="(item, index) in A3TestItem2"
                      :key="index"
                      :class="istrueindex == index ? 'active' : ''"
                    >
                      <div>小题{{ index + 1 }}</div>
                    </div>
                  </div>
                  <div class="samll_right">
                    <el-button @click="gitSmall">
                      <i class="iconfont icon-action-add-hover"></i>添加小题
                    </el-button>
                    <el-button @click="deleteSmall('共享题')">
                      <i class="iconfont icon-zu11540"></i>删除小题
                    </el-button>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="小题干：" prop="Title" class="text_one">
                <el-input
                  type="textarea"
                  v-model.trim="A3TestItem2[istrueindex].Title"
                  placeholder="请输入小题干"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项：" prop="SelectedItem" class="text_one">
                <div
                  v-for="(item, index) in A3TestItem2[istrueindex].SelectedItem"
                  :key="index"
                >
                  <div class="options_view">
                    <div class="options_text">{{ add(index) }}</div>
                    <div class="options_box">
                      <el-input v-model="item.value"></el-input>
                      <i
                        class="iconfont icon-zu11540"
                        @click="smallRadioDele(index, '共享题')"
                        v-if="index > 1 && ruleForm.radioArr.length > 2"
                      ></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <!-- 小题干选题的多选框 -->
              <el-form-item
                label="答案："
                prop="options"
                class="check_box text_one"
              >
                <el-checkbox-group v-model="A3TestItem2[istrueindex].Answer">
                  <div
                    v-for="(item, index) in A3TestItem2[istrueindex]
                      .SelectedItem"
                    :key="index"
                  >
                    <el-checkbox :label="add(index)">{{
                      add(index)
                    }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </el-form-item>
              <el-button class="oper_box" @click="addSmallRadio('共用题干')">
                <i class="iconfont icon-action-add-hover"></i>添加选项
              </el-button>
              <el-form-item label="解析：" prop="parsing">
                <div class="parsing">
                  <el-input
                    type="textarea"
                    v-model.trim="A3TestItem2[istrueindex].parsing"
                    placeholder="请输入解析"
                    maxlength="250"
                    show-word-limit
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div v-else-if="state == 7" class="small_choice">
            <el-form
              :model="smallForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <!-- 小题盒子部分 -->
              <el-form-item>
                <div class="samll_topic">
                  <div class="samll_left">
                    <div
                      @click="AdSwitchtable(index)"
                      v-for="(item, index) in isSmalFlorm.BTestItem"
                      :key="index"
                      :class="istrueindex == index ? 'active' : ''"
                    >
                      <div>小题{{ index + 1 }}</div>
                    </div>
                  </div>
                  <div class="samll_right">
                    <el-button @click="AddSmall">
                      <i class="iconfont icon-action-add-hover"></i>添加小题
                    </el-button>
                    <el-button @click="deleteSmall('配伍题')">
                      <i class="iconfont icon-zu11540"></i>删除小题
                    </el-button>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="小题干：" prop="Title" class="text_one">
                <el-input
                  type="textarea"
                  v-model.trim="isSmalFlorm.BTestItem[istrueindex].Title"
                  placeholder="请输入小题干"
                ></el-input>
              </el-form-item>

              <el-form-item label="选项：" prop="SelectedItem" class="text_one">
                <div
                  v-for="(item, index) in isSmalFlorm.SelectedItem"
                  :key="index"
                >
                  <div class="options_view">
                    <div class="options_text">{{ add(index) }}</div>
                    <div class="options_box">
                      <el-input v-model="item.value"></el-input>
                      <i
                        class="iconfont icon-zu11540"
                        @click="smallRadioDele(index, '配伍题')"
                        v-if="index > 1 && ruleForm.radioArr.length > 2"
                      ></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-button class="oper_box" @click="addSmallRadio('配伍题')">
                <i class="iconfont icon-action-add-hover"></i>添加选项
              </el-button>

              <!-- 单选题的单选框 -->
              <el-form-item
                label="答案："
                prop="options"
                class="check_box text_one"
              >
                <el-radio-group
                  v-model="isSmalFlorm.BTestItem[istrueindex].Answer"
                >
                  <div
                    v-for="(item, index) in isSmalFlorm.SelectedItem"
                    :key="index"
                  >
                    <div class="radio">
                      <el-radio :label="add(index)">{{ add(index) }}</el-radio>
                    </div>
                  </div>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="解析：" prop="parsing">
                <div class="parsing">
                  <el-input
                    type="textarea"
                    v-model.trim="isSmalFlorm.BTestItem[istrueindex].Explain"
                    placeholder="请输入解析"
                    maxlength="250"
                    show-word-limit
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div v-else-if="state == 8" class="judge_choice">
            <el-form
              :model="judgeForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="题干：" prop="Title" class="text_one">
                <el-input
                  type="textarea"
                  v-model.trim="judgeForm.Title"
                  placeholder="请输入题干"
                ></el-input>
              </el-form-item>
              <!-- 单选题的单选框 -->
              <el-form-item
                label="答案："
                prop="Answer"
                class="check_box text_one"
              >
                <el-radio-group v-model="judgeForm.Answer">
                  <el-radio label="对">对</el-radio>
                  <el-radio label="错">错</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="解析：" prop="Explain">
                <div class="parsing">
                  <el-input
                    type="textarea"
                    v-model.trim="judgeForm.Explain"
                    placeholder="请输入解析"
                    maxlength="250"
                    show-word-limit
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm('ruleForm')">取 消</el-button>
          <el-button type="primary" @click="submitForm()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { addtest, UpDate } from "@/api/quebankmana.js";
import { numberChinese } from "@/utils/Theletter"; //这是字母
import loginvuex from "@/store/index";
import qs from "qs";
export default {
  data() {
    return {
      dialogVisible: false,
      state: 1, // 内容切换状态
      form: {
        topic: "填空题",
        topicName: "填空题",
      },
      ruleForm: {
        Title: "", // 题干
        isslectradio: "", //单选框组选中的值
        checkList: [], // 多选框选中的值
        Answer: [
          // 填空题答案
          {
            value: "",
          },
        ],
        isAnswer: "", // 问答题答案
        Explain: "", //解析
        radioArr: [
          {
            value: "", // input值
          },
          {
            value: "",
          },
          {
            value: "",
          },
          {
            value: "",
          },
        ],
        options: [
          // 单项选择题选项
          {
            value: "", // input值
          },
          {
            value: "",
          },
          {
            value: "",
          },
          {
            value: "",
          },
        ],
      },
      // 共享题干单选题，添加小题干的具体内容。
      smallForm: {
        MainTitle: "", // 题干 此处区分单选还是多选
        MainTitle2: "",
        Title: "", // 小题干
        Answer: "", //单选框组选中的值
        SelectedItem: [
          {
            value: "",
          },
          {
            value: "",
          },
          {
            value: "",
          },
          {
            value: "",
          },
        ],
        parsing: "", // 解析
      },
      // 配伍题单独定义
      isSmalFlorm: {
        ID: "", //
        TestType: "", //题的类型
        MainTitle: "", // 题干
        Explain: "", //说明
        TestPoint: "", //
        SelectedItem: [
          // 选项
          {
            value: "",
          },
          {
            value: "",
          },
          {
            value: "",
          },
          {
            value: "",
          },
        ],
        BTestItem: [
          {
            ID: "", //
            TestType: "", //题的类型
            Title: "", // 小题干
            Explain: "", // 解析
            TestPoint: "略",
            Answer: "", //单选框组选中的值,传一个就是单选，多个就是多选
          },
        ],
        // parsing: "", // 解析
      },
      smallFormarr: [], //共享题干单选题，全部题型数组。
      istrueindex: 0, //当前选中的table
      options: [
        {
          id: 1,
          value: "选项1",
          label: "填空题",
        },
        {
          id: 2,
          value: "选项2",
          label: "问答题",
        },
        {
          id: 3,
          value: "选项3",
          label: "单项选择题",
        },
        {
          id: 4,
          value: "选项4",
          label: "多项选择题",
        },
        {
          id: 5,
          value: "选项5",
          label: "共用题干单选题",
        },
        {
          id: 6,
          value: "选项6",
          label: "共用题干不定项选择题",
        },
        {
          id: 7,
          value: "选项7",
          label: "配伍题",
        },
        {
          id: 8,
          value: "选项8",
          label: "判断题",
        },
      ],
      zitem: "", //  每个小题干的输入框
      selectSamll: [], // 每个选项
      A3TestItem: [
        {
          ID: "", //
          TestType: "", //题的类型
          Title: "", // 小题干
          Explain: "", //说明
          TestPoint: "", //
          SelectedItem: [
            {
              value: "",
            },
            {
              value: "",
            },
            {
              value: "",
            },
            {
              value: "",
            },
          ],
          Answer: [], //单选框组选中的值,传一个就是单选，多个就是多选
          parsing: "", // 解析
        },
      ], // 小题干数据
      A3TestItem2: [
        // 多选的
        {
          ID: "", //
          TestType: "", //题的类型
          Title: "", // 小题干
          Explain: "", //说明
          TestPoint: "", //
          SelectedItem: [
            {
              value: "",
            },
            {
              value: "",
            },
            {
              value: "",
            },
            {
              value: "",
            },
          ],
          Answer: [], //单选框组选中的值,传一个就是单选，多个就是多选
          parsing: "", // 解析
        },
      ], // 小题干数据
      judgeForm: {
        //判断题表单
        Title: "", //题干
        Explain: "", // 解析
        Answer: "", //答案
        TestType: "PDTEST",
        TestPoint: "",
        ID: "-1",
      },
      yuanshidata: "", //页面的data原始状态
    };
  },
  methods: {
    choose(selVal) {
      this.form.topicName = selVal.label;
      this.state = selVal.id; // 对应的id暂时不同的内容
      console.log(this.state, 0);
    },
    // 取消重置
    resetForm(formName) {
      this.resetdata();
      // this.$destroy()
      // this.ruleForm.Answer = []
      this.dialogVisible = false;
    },
    // 表单验证
    async submitForm() {
      let StyleName; //题型的类型
      let resa; //返回的题型的json
      if (this.state == 1) {
        resa = this.sendtiankong(); //验证错误就是返回一个空
        if (!resa) {
          return;
        }
        StyleName = "填空题";
      } else if (this.state == 2) {
        resa = this.sendwenda();
        if (!resa) {
          return;
        }
        StyleName = "问答题";
      } else if (this.state == 3) {
        resa = this.senddanxuan();
        if (!resa) {
          return;
        }
        StyleName = "单项选择题";
      } else if (this.state == 4) {
        resa = this.sendduoxuan();
        if (!resa) {
          return;
        }
        StyleName = "多项选择题";
      } else if (this.state == 5) {
        resa = this.sendtogeterdanxuan();
        if (!resa) {
          return;
        }
        StyleName = "共用题干单选题";
      } else if (this.state == 6) {
        resa = this.sendtogeterdanxuan();
        if (!resa) {
          return;
        }
        StyleName = "共用题干不定项选择题";
      } else if (this.state == 7) {
        resa = this.peiwuti();
        if (!resa) {
          return;
        }
        StyleName = "配伍题";
      } else if (this.state == 8) {
        resa = this.panduan();
        if (!resa) {
          return;
        }
        StyleName = "判断题";
      }
      let parmass = {
        CptID: this.$parent.$parent.$parent.islooktestid,
        _testJson: resa,
        StyleName: this.form.topicName,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      // 0是添加，1是编辑
      if (this.$parent.$parent.editorState == 0) {
        const Data = await addtest(qs.stringify(parmass));
        if (Data.data.Status == 200) {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          this.resetdata();
          this.dialogVisible = false;
          setTimeout(() => {
            this.$parent.$parent.getpaperdata();
          }, 500);
        } else {
          this.$message.error(Data.data);
        }
      } else if (this.$parent.$parent.editorState == 1) {
        // parmass.CptID = this.$parent.$parent.addData.TestID
        const Data = await UpDate(qs.stringify(parmass));
        if (Data.data.Status == 200) {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success",
          });
          this.resetdata();
          this.dialogVisible = false;
          setTimeout(() => {
            this.$parent.$parent.getpaperdata();
          }, 500);
        } else {
          this.$message.error(Data.data);
        }
      }
    },
    // 添加答案
    addAnswer() {
      if (this.state == 1) {
        this.ruleForm.Answer.push({ value: "" }); // 增加答案
      } else if (this.state == 3) {
        this.ruleForm.radioArr.push({ value: "" }); // 增加单选框
      } else if (this.state == 4) {
        this.ruleForm.options.push({ value: "" }); // 增加多选框
      }
    },
    // 删除答案
    deletes(index) {
      if (this.state == 1) {
        this.ruleForm.Answer.pop();
      } else if (this.state == 3) {
        this.ruleForm.radioArr.splice(index, 1); // 删除单选框
      } else if (this.state == 4) {
        this.ruleForm.options.splice(index, 1); // 删除多选框
      }
    },
    // 增加小题干单选框
    addSmallRadio(item) {
      console.log(item, "item");

      if (item == "配伍题") {
        this.isSmalFlorm.SelectedItem.push({ value: "" });
      } else if (item == "共用题干") {
        if (this.state == 5) {
          this.A3TestItem[this.istrueindex].SelectedItem.push({ value: "" });
        } else if (this.state == 6) {
          this.A3TestItem2[this.istrueindex].SelectedItem.push({ value: "" });
        }
      }
    },
    // 删除小题干单选框
    smallRadioDele(index, text) {
      if (text == "配伍题") {
        this.isSmalFlorm.SelectedItem.splice(index, 1);
      } else if (text == "共享题") {
        if (this.state == 5) {
          this.A3TestItem[this.istrueindex].SelectedItem.splice(index, 1);
        } else if (this.state == 6) {
          this.A3TestItem2[this.istrueindex].SelectedItem.splice(index, 1);
        }
      }
    },
    // 字母计算
    add(index) {
      return numberChinese(index);
    },
    // 配伍题的切换小题 -->单独定义
    AdSwitchtable(index) {
      if (this.isSmalFlorm.BTestItem[this.istrueindex].Title == "") {
        this.$message.error("请输入正确的小题干");
        return;
      } else if (this.isSmalFlorm.BTestItem[this.istrueindex].Answer == "") {
        this.$message.error("请输入正确答案");
        return;
      }
      this.istrueindex = index;
    },
    //切换小题
    switchtable(indexs) {
      const title =
        this.state == 5
          ? this.A3TestItem[this.istrueindex].Title
          : this.A3TestItem2[this.istrueindex].Title;
      const answer =
        this.state == 5
          ? this.A3TestItem[this.istrueindex].Answer
          : this.A3TestItem2[this.istrueindex].Answer;
      if (title == "") {
        this.$message.error("请输入正确的小题干");
        return;
      } else if (answer == "") {
        this.$message.error("请输入正确答案");
        return;
      }
      this.istrueindex = indexs;
    },
    // 删除小题
    deleteSmall(text) {
      if (text == "共享题") {
        if (this.state == 5) {
          this.checkItemLengthAndDel(this.A3TestItem);
        } else if (this.state == 6) {
          this.checkItemLengthAndDel(this.A3TestItem2);
        }
      } else if (text == "配伍题") {
        this.checkItemLengthAndDel(this.isSmalFlorm.BTestItem);
      }
    },
    //删除小题时，校验至少保留一个
    checkItemLengthAndDel(item) {
      if (item.length < 2) {
        this.$message.error("至少保留一个小题");
        return;
      }
      item.splice(this.istrueindex, 1);
      //删除数据后需要重新设置当前选中的下标
      this.istrueindex = item.length - 1;
    },
    // 添加小题干 配伍题单独定义
    AddSmall() {
      this.isSmalFlorm.SelectedItem.map((item) => {
        this.zitem = item.value;
        this.selectSamll.push(item.value);
      });
      let ispeiwuxuanxiang = true; //配伍题有值得时候
      this.isSmalFlorm.SelectedItem.map((item) => {
        if (item.value == "") {
          ispeiwuxuanxiang = false;
        }
        this.selectSamll.push(item.value);
      });
      if (ispeiwuxuanxiang == false) {
        this.$message.error("请输入选项2");
      } else if (this.isSmalFlorm.BTestItem[this.istrueindex].Title == "") {
        this.$message.error("请输入小题干");
      } else if (this.isSmalFlorm.BTestItem[this.istrueindex].Answer == "") {
        this.$message.error("请输入正确答案");
      } else {
        // 验证通过
        let res = {
          ID: this.isSmalFlorm.BTestItem.length,
          TestType: "ATEST",
          Title: "", //小题干
          Explain: "", //解析
          TestPoint: "略",
          SelectedItem: [
            {
              value: "",
            },
            {
              value: "",
            },
            {
              value: "",
            },
            {
              value: "",
            },
          ], // 输入框
          Answer: [], // 答案
        };
        this.isSmalFlorm.BTestItem.push(res);
        this.istrueindex = this.isSmalFlorm.BTestItem.length - 1;
      }
    },
    // 添加小题 单选题
    gitSmall() {
      if (this.state == 5) {
        this.A3TestItem[this.istrueindex].SelectedItem.map((item) => {
          this.zitem = item.value;
          this.selectSamll.push(item.value);
        });
      } else if (this.state == 6) {
        this.A3TestItem2[this.istrueindex].SelectedItem.map((item) => {
          this.zitem = item.value;
          this.selectSamll.push(item.value);
        });
      }
      let ispeiwuxuanxiang = true; //配伍题有值得时候
      const Title =
        this.state == 5
          ? this.A3TestItem[this.istrueindex].Title
          : this.A3TestItem2[this.istrueindex].Title;
      const Answer =
        this.state == 5
          ? this.A3TestItem[this.istrueindex].Answer
          : this.A3TestItem2[this.istrueindex].Answer;
      this.smallForm.SelectedItem.map((item) => {
        if (item.value == "") {
          ispeiwuxuanxiang = false;
        }
        this.selectSamll.push(item.value);
      });
      if (this.smallForm.desc == "") {
        this.$message.error("请输入题干");
      } else if (Title == "") {
        this.$message.error("请输入小题干");
      } else if (this.zitem == "") {
        this.$message.error("请输入选项");
      } else if (Answer == "") {
        this.$message.error("请输入正确答案");
      } else {
        // 验证通过
        let res = {
          ID:
            this.state == 5 ? this.A3TestItem.length : this.A3TestItem2.length,
          TestType: "ATEST",
          Title: "", //小题干
          Explain: "", //解析
          TestPoint: "略",
          SelectedItem: [
            {
              value: "",
            },
            {
              value: "",
            },
            {
              value: "",
            },
            {
              value: "",
            },
          ], // 输入框
          Answer: [], // 答案
        };
        if (this.state == 5) {
          this.A3TestItem.push(res);
          this.istrueindex = this.A3TestItem.length - 1;
        } else if (this.state == 6) {
          this.A3TestItem2.push(res);
          this.istrueindex = this.A3TestItem2.length - 1;
        }
      }
    },
    //填空题并发请求
    sendtiankong() {
      let isanswer = true; //是否填写完成的答案
      let resa = this.ruleForm.Answer.map((item) => {
        if (item.value == "") {
          isanswer = false;
        }
        return item.value;
      });
      if (this.ruleForm.Title == "") {
        this.$message({
          showClose: true,
          message: "请填写题干",
          type: "error",
        });
        return;
      }
      if (!isanswer) {
        this.$message({
          showClose: true,
          message: "请填写完整的答案",
          type: "error",
        });
        return;
      }
      let params = {
        ID: "-1",
        TestType: "TKTEST",
        Title: this.ruleForm.Title,
        Explain: this.ruleForm.Explain,
        TestPoint: "",
        TKTestIsorderly: "1", //不知道啥意思
        Answer: resa,
      };
      if (this.$parent.$parent.editorState == 1) {
        params.ID = this.$parent.$parent.addData.TestID; // 编辑传ID
      }
      return JSON.stringify(params);
    },
    //问答题并发验证请求
    sendwenda() {
      if (!this.ruleForm.Title) {
        this.$message({
          showClose: true,
          message: "请填写题干",
          type: "error",
        });
        return;
      }
      if (!this.ruleForm.isAnswer) {
        this.$message({
          showClose: true,
          message: "请填写答案",
          type: "error",
        });
        return;
      }
      let params = {
        ID: "-1",
        TestType: "JDTEST",
        Title: this.ruleForm.Title,
        Explain: this.ruleForm.Explain,
        TestPoint: "",
        //  TKTestIsorderly: "1", //不知道啥意思
        Answer: this.ruleForm.isAnswer,
      };
      if (this.$parent.$parent.editorState == 1) {
        params.ID = this.$parent.$parent.addData.TestID; // 编辑传ID
      }
      return JSON.stringify(params);
    },
    //单向选择题
    senddanxuan() {
      let isselect = true;
      if (!this.ruleForm.Title) {
        this.$message({
          showClose: true,
          message: "请填写题干",
          type: "error",
        });
        return;
      }
      let resa = this.ruleForm.radioArr.map((item) => {
        if (item.value == "") {
          isselect = false;
        }
        return item.value;
      });
      if (!isselect) {
        this.$message({
          showClose: true,
          message: "请填写完整答案选项",
          type: "error",
        });
        return;
      }
      if (!this.ruleForm.isslectradio) {
        this.$message({
          showClose: true,
          message: "请填写完整答案",
          type: "error",
        });
        return;
      }
      let params = {
        ID: "-1",
        TestType: "ATEST",
        Title: this.ruleForm.Title,
        Explain: this.ruleForm.Explain,
        TestPoint: "",
        SelectedItem: resa,
        Answer: this.ruleForm.isslectradio,
      };
      if (this.$parent.$parent.editorState == 1) {
        params.ID = this.$parent.$parent.addData.TestID; // 编辑传ID
      }
      return JSON.stringify(params);
    },
    //多想选择题
    sendduoxuan() {
      let isselect = true;
      if (!this.ruleForm.Title) {
        this.$message({
          showClose: true,
          message: "请填写题干",
          type: "error",
        });
        return;
      }
      let resa = this.ruleForm.options.map((item) => {
        if (item.value == "") {
          isselect = false;
        }
        return item.value;
      });
      console.log(isselect);
      if (!isselect) {
        this.$message({
          showClose: true,
          message: "请填写完整答案选项",
          type: "error",
        });
        return;
      }
      if (this.ruleForm.checkList.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择至少一个答案",
          type: "error",
        });
        return;
      }
      let params = {
        ID: "-1",
        TestType: "XTEST",
        Title: this.ruleForm.Title,
        Explain: this.ruleForm.Explain,
        TestPoint: "",
        SelectedItem: resa,
        Answer: this.ruleForm.checkList.reduce((first, scend) => {
          return first + scend;
        }),
      };
      if (this.$parent.$parent.editorState == 1) {
        params.ID = this.$parent.$parent.addData.TestID; // 编辑传ID
      }
      return JSON.stringify(params);
    },
    //共用题干单选
    sendtogeterdanxuan() {
      let isselect = true; //小题单选选项是否呗选中。
      const MainTitle = this.state == 5 ?this.smallForm.MainTitle :this.smallForm.MainTitle2
      if (!MainTitle) {
        this.$message({
          showClose: true,
          message: "请填写题干",
          type: "error",
        });
        return;
      }
      const Title =
        this.state == 5
          ? this.A3TestItem[this.istrueindex].Title
          : this.A3TestItem2[this.istrueindex].Title;

      let SelectedItem =
        this.state == 5
          ? this.A3TestItem[this.istrueindex].SelectedItem
          : this.A3TestItem2[this.istrueindex].SelectedItem;
      let Answer =
        this.state == 5
          ? this.A3TestItem[this.istrueindex].Answer
          : this.A3TestItem2[this.istrueindex].Answer;
      if (!Title) {
        this.$message({
          showClose: true,
          message: "请填写小题干",
          type: "error",
        });
        return;
      }
      let resa = SelectedItem.map((item) => {
        console.log(item, "???");

        if (item.value == "") {
          isselect = false;
        }
        return item.value;
      });
      if (!isselect) {
        this.$message({
          showClose: true,
          message: "请填写完整答案选项",
          type: "error",
        });
        return;
      }
      if (Answer.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择至少一个答案",
          type: "error",
        });
        return;
      }
      if (this.state == 5) {
        this.A3TestItem.forEach((item, index) => {
          item["ID"] = index + 1;
          item["TestType"] = "ATEST";
          item["Explain"] = "";
          item["TestPoint"] = "略";
          item.SelectedItem = item.SelectedItem.map((items) => {
            return items.value;
          });
          console.log(item.SelectedItem);
          if (this.state == 5) {
            item.Answer = [...item.Answer];
          }
        });
      }else if (this.state ==6){
        this.A3TestItem2.forEach((item, index) => {
          item["ID"] = index + 1;
          item["TestType"] = "ATEST";
          item["Explain"] = "";
          item["TestPoint"] = "略";
          item.SelectedItem = item.SelectedItem.map((items) => {
            return items.value;
          });
          console.log(item.SelectedItem);
          if (this.state == 5) {
            item.Answer = [...item.Answer];
          }
        });
      }

      let parmas = {
        ID: "-1",
        TestType: "A3TEST",
        MainTitle: this.state == 5 ? this.smallForm.MainTitle:this.smallForm.MainTitle2,
        Explain: "略",
        TestPoint: "",
        A3TestItem: this.state == 5?this.A3TestItem:this.A3TestItem2,
      };
      if (this.$parent.$parent.editorState == 1) {
        parmas.ID = this.$parent.$parent.addData.TestID; // 编辑传ID
      }
      return JSON.stringify(parmas);
    },
    //配伍题
    peiwuti() {
      let tigan = true; //
      let resa = this.isSmalFlorm.SelectedItem.map((item) => {
        if (item.value == "") {
          tigan = false;
        }
        return item.value;
      });
      if (this.isSmalFlorm.BTestItem[this.istrueindex].Title == "") {
        this.$message.error("请输入正确的小题干");
        return;
      } else if (this.isSmalFlorm.BTestItem[this.istrueindex].Answer == "") {
        this.$message.error("请输入正确答案");
        return;
      } else if (!tigan) {
        this.$message.error("请输入完整的选项");
        return;
      }
      this.isSmalFlorm.BTestItem.forEach((item, index) => {
        item["ID"] = index + 1;
        item["TestType"] = "ATEST";
        item["Explain"] = "";
        item["TestPoint"] = "略";
        item.Answer = item.Answer;
        item.SelectedItem = undefined;
      });
      let parmas = {
        ID: "-1",
        TestType: "BTEST",
        MainTitle: "",
        Explain: "略",
        TestPoint: "",
        SelectedItem: resa,
        BTestItem: this.isSmalFlorm.BTestItem,
      };
      if (this.$parent.$parent.editorState == 1) {
        parmas.ID = this.$parent.$parent.addData.TestID; // 编辑传ID
      }
      return JSON.stringify(parmas);
    },
    panduan() {
      if (!this.judgeForm.Title) {
        this.$message({
          showClose: true,
          message: "请填写题干",
          type: "error",
        });
        return;
      }
      if (!this.judgeForm.Answer) {
        this.$message({
          showClose: true,
          message: "请填写结果",
          type: "error",
        });
        return;
      }
      let params = {
        ID: "-1",
        TestType: "PDTEST",
        Title: this.judgeForm.Title,
        Explain: this.judgeForm.Explain,
        TestPoint: "",
        Answer: this.judgeForm.Answer,
      };
      if (this.$parent.$parent.editorState == 1) {
        params.ID = this.$parent.$parent.addData.TestID; // 编辑传ID
      }
      return JSON.stringify(params);
    },
    //重置弹框数据
    resetdata() {
      Object.assign(
        this.$data,
        JSON.parse(JSON.stringify(this.$parent.dialogdata))
      );
    },
  },
  created() {
    this.$nextTick(() => {
      this.$parent.dialogdata = this.$options.data();
    });
  },
};
</script>
<style lang="scss" scoped>
.mian_box {
  height: 850px;
  ::v-deep .el-dialog {
    width: 865px !important;
    height: 850px;
    overflow: hidden;
    overflow-y: scroll;
    border-radius: 5px 5px 0px 0px;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog__body {
    padding: 24px;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    line-height: 24px;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 22px;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
  .Popup_view {
    padding: 26px 24px;
    ::v-deep .el-form {
      display: flex;
      .el-input__inner {
        width: 300px;
        height: 40px;
      }
      .el-form-item {
        &:nth-child(2) {
          margin-left: 24px;
        }
      }
      .el-form-item__label {
        width: 82px !important;
        text-align: left;
      }
      .el-form-item__content {
        margin-left: 82px !important;
      }
    }
    .rule_mian {
      ::v-deep .el-form {
        display: flex;
        flex-direction: column;
        .parsing {
          .el-textarea__inner {
            width: 705px;
          }
        }
        .check_box {
          .el-form-item__content {
            margin: 0 !important;
            display: flex;
          }
        }
        .el-form-item__label {
          height: 30px;
          line-height: 30px;
        }
        .el-input {
          &:nth-child(1) {
            width: 705px;
            height: 100px;
          }
        }
        .el-form-item {
          .el-textarea__inner {
            height: 100px;
          }
          &:nth-child(1) {
            .el-textarea__inner {
              width: 705px;
              height: 100px;
            }
          }
          &:nth-child(2) {
            margin-left: 0px;
          }
          .el-form-item__label {
            &::before {
              display: none;
            }
          }
          .answer_oper {
            display: flex;
            align-items: center;
            .el-textarea__inner {
              width: 655px;
            }
            i {
              display: inline-block;
              font-size: 20px;
              color: #ff5e5e;
              margin-left: 12px;
            }
          }
          .answer {
            .el-textarea__inner {
              width: 705px;
            }
          }
          .parsing {
            .el-textarea__inner {
              width: 705px;
            }
          }
        }
      }
    }
    .choice_mian {
      ::v-deep .el-form {
        display: flex;
        flex-direction: column;
        .radio {
          margin-right: 12px;
        }
        .el-textarea__inner {
          width: 705px;
          height: 100px;
        }
        .el-radio-group {
          display: flex;
        }
        .el-form-item__label {
          &::before {
            display: none;
          }
        }
        .el-form-item {
          &:nth-child(2) {
            margin-left: 0px;
          }
        }
        .parsing {
          .el-textarea__inner {
            width: 705px;
          }
        }
        .check_box {
          .el-form-item__content {
            margin: 0 !important;
            display: flex;
          }
          .el-checkbox {
            display: inline-block;
            margin-right: 12px;
          }
        }
        .el-checkbox-group {
          display: flex;
        }
        .el-form-item__label {
          height: 30px;
          line-height: 30px;
        }
        .options_view {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .options_text {
            width: 60px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #d9d9d9;
            border-radius: 4px 0px 0px 4px;
          }
          .options_box {
            display: flex;
            align-items: center;
            .el-input__inner {
              height: 30px;
              width: 594px;
            }
            i {
              display: inline-block;
              font-size: 20px;
              color: #ff5e5e;
              margin-left: 12px;
            }
          }
          .parsing {
            .el-textarea__inner {
              width: 705px;
            }
          }
        }
      }
    }
    .small_choice {
      ::v-deep .el-form {
        display: flex;
        flex-direction: column;
        .el-checkbox-group {
          display: flex;
          > div {
            margin-right: 12px;
          }
        }
        .options_view {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .options_text {
            width: 60px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #d9d9d9;
            border-radius: 4px 0px 0px 4px;
          }
          .options_box {
            display: flex;
            align-items: center;
            .el-input__inner {
              height: 30px;
              width: 594px;
            }
            i {
              display: inline-block;
              font-size: 20px;
              color: #ff5e5e;
              margin-left: 12px;
            }
          }
          .parsing {
            .el-textarea__inner {
              width: 705px;
            }
          }
        }
        .el-radio-group {
          display: flex;
          .radio {
            margin-right: 12px;
          }
        }
        .el-radio:last-child {
          height: 30px;
          line-height: 30px;
        }
        .el-form-item__label {
          height: 30px;
          line-height: 30px;
        }
        .el-textarea__inner {
          width: 705px;
          height: 100px;
        }
        .el-form-item__label {
          &::before {
            display: none;
          }
        }
        .el-form-item {
          &:nth-child(2) {
            margin-left: 0px;
          }
        }
        .samll_topic {
          width: 705px;
          height: 30px;
          background: #eff7ff;
          display: flex;
          justify-content: space-between;
          .samll_left {
            display: flex;
            justify-content: flex-start;
            > div {
              width: 60px;
              height: 30px;
              line-height: 30px;
              text-align: center;
            }
          }
          .samll_right {
            display: flex;
            width: 208px;
            .el-button {
              width: 104px;
              height: 30px;
              line-height: 6px;
              text-align: center;
              color: #ffffff;
              span > i {
                font-size: 14px !important;
                margin-right: 5px;
              }
              &:nth-child(1) {
                background: #1890ff;
              }
              &:nth-child(2) {
                background: #e54d4d;
                margin: 0;
              }
            }
          }
        }
      }
    }
    .judge_choice {
      ::v-deep .el-form {
        display: flex;
        flex-direction: column;
        .el-checkbox-group {
          display: flex;
          > div {
            margin-right: 12px;
          }
        }
        .el-form-item__label {
          height: 30px;
          line-height: 30px;
        }
        .el-textarea__inner {
          width: 705px;
          height: 100px;
        }
        .el-form-item__label {
          &::before {
            display: none;
          }
        }
        .el-form-item {
          &:nth-child(2) {
            margin-left: 0px;
          }
        }
      }
    }
  }
}
.oper_box {
  width: 104px;
  height: 30px;
  background: #1890ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  letter-spacing: 1px;
  margin-left: 80px;
  span > i {
    font-size: 14px !important;
    margin-right: 5px;
  }
  margin-bottom: 30px;
}
.block {
  display: block;
}
.active {
  background: #1890ff;
  color: #ffffff;
}
.text_one {
  display: inline-block;
  // margin: 0px 10px 0px 10px;
  min-width: 80px;
  font-size: 14px;
  line-height: 40px;
  position: relative;
  &::after {
    content: "*";
    position: absolute;
    display: block;
    left: -8px;
    top: -8px;
    color: red;
    font-size: 16px;
  }
}
</style>